import { auto } from "@popperjs/core";
import React, { FC, ReactNode } from "react";

interface Props {
  children: ReactNode
  width:number
}

export const TableData: FC<Props> = ({children , width }) => {
  
  return (
    <td scope="row"
      style={{ height:'40px', width: `${width}%`,verticalAlign:'middle'}}
      className={`px-6`}
    >
      {children}
    </td>
  );
};


